module.exports = __webpack_public_path__ + "img/goal-secondary-thick.6c7b9397.svg";